import Vue from "vue";
import Login from "./views/Login.vue";
import PageNotFound from "./views/PageNotFound.vue";
import Protected from "./views/Protected.vue";
import { IonicVueRouter } from "@ionic/vue";
import { isLoggedIn } from "@/api/auth";
import store from "@/store";
import { Plugins } from "@capacitor/core";
import { logout } from "./api/auth";
import { isPageLoggedOutAllowed } from "@/utils";
import { checkPageAccess } from "./utils";

const { Browser } = Plugins;

Vue.use(IonicVueRouter);

const router = new IonicVueRouter({
    // mode: "history",
    base: process.env.BASE_URL,
    routes: [
        { path: "/", redirect: { name: "dashboard" } },
        {
            path: "/login",
            name: "login",
            component: Login,
        },
        {
            path: "/aktivierung",
            name: "aktivierung",
            component: () =>
                import(
                    /* webpackChunkName: "services" */ "@/views/Activation.vue"
                ),
        },
        {
            path: "/dashboard",
            name: "dashboard",
            components: {
                dashboard: () =>
                    import(
                        /* webpackChunkName: "dashboard" */ "@/views/Dashboard.vue"
                    ),
            },
            props: { dashboard: true },
        },
        {
            path: "/services",
            name: "services",
            component: () =>
                import(
                    /* webpackChunkName: "services" */ "@/views/Services.vue"
                ),
        },
        {
            path: "/vertraege",
            name: "vertraege",
            components: {
                vertraege: () =>
                    import(
                        /* webpackChunkName: "vertraege" */ "@/views/DocumentsContracts.vue"
                    ),
            },
        },
        {
            path: "/nachrichten",
            name: "nachrichten",
            components: {
                nachrichten: () =>
                    import(
                        /* webpackChunkName: "nachrichten" */ "@/views/Postbox.vue"
                    ),
            },
        },
        {
            path: "/menu",
            name: "menu",
            components: {
                menu: () =>
                    import(/* webpackChunkName: "menu" */ "@/views/Menu.vue"),
            },
        },
        {
            path: "/services/me1ns",
            name: "me1ns",
            component: () =>
                import(/* webpackChunkName: "berater" */ "@/views/Me1ns.vue"),
        },
        {
            path: "/services/berater",
            name: "berater",
            component: () =>
                import(/* webpackChunkName: "berater" */ "@/views/Coaches.vue"),
            props: true,
        },
        // {
        //     path: "/services/immowert",
        //     name: "immowert",
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "berater" */ "@/views/ImmoWert.vue"
        //         ),
        //     props: true,
        // },
        {
            path: "/:motive/kreditcheckliste",
            name: "kreditcheckliste",
            component: () =>
                import(
                    /* webpackChunkName: "kreditcheckliste" */ "@/views/Kreditcheckliste.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung",
            name: "schadensmeldung",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung" */ "@/views/Schadensmeldung.vue"
                ),
        },
        {
            path: "/services/schadensmeldung-neu",
            name: "schadensmeldung-neu",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-neu" */ "@/views/SchadensmeldungNeu.vue"
                ),
        },
        {
            path: "/services/schadensmeldung/kfz/:contractId?",
            name: "schadensmeldung-kfz",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-kfz" */ "@/views/SchadensmeldungKfz.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/kfz-neu/:contractId?",
            name: "schadensmeldung-kfz-neu",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-kfz-neu" */ "@/views/SchadensmeldungKfzNeu.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/haushalt/:contractId?",
            name: "schadensmeldung-haushalt",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-haushalt" */ "@/views/SchadensmeldungHaushalt.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/haushalt-neu/:contractId?",
            name: "schadensmeldung-haushalt-neu",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-haushalt-neu" */ "@/views/SchadensmeldungHaushaltNeu.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/sachversicherung/:contractId?",
            name: "schadensmeldung-sach",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-sach" */ "@/views/SchadensmeldungSach.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/sachversicherung-neu/:contractId?",
            name: "schadensmeldung-sach-neu",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-sach-neu" */ "@/views/SchadensmeldungSachNeu.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/rechtsschutz/:contractId?",
            name: "schadensmeldung-recht",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-recht" */ "@/views/SchadensmeldungRecht.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/rechtsschutz-neu/:contractId?",
            name: "schadensmeldung-recht-neu",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-recht-neu" */ "@/views/SchadensmeldungRechtNeu.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/krankenhaus/:contractId?",
            name: "schadensmeldung-krankenhaus",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-krankenhaus" */ "@/views/SchadensmeldungKrankenhaus.vue"
                ),
            props: true,
        },
        {
            path: "/services/schadensmeldung/unfall/:contractId?",
            name: "schadensmeldung-unfall",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-unfall" */ "@/views/SchadensmeldungUnfall.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/schadensmeldung",
            name: "motive-schadensmeldung",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung" */ "@/views/Schadensmeldung.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/schadensmeldung/kfz",
            name: "motive-schadensmeldung-kfz",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-kfz" */ "@/views/SchadensmeldungKfz.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/schadensmeldung/haushalt",
            name: "motive-schadensmeldung-haushalt",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-haushalt" */ "@/views/SchadensmeldungHaushalt.vue"
                ),
            props: true,
        },
        {
            path:
                "/:motive/vertrag/:contractId/schadensmeldung/sachversicherung",
            name: "motive-schadensmeldung-sach",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-sach" */ "@/views/SchadensmeldungSach.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/schadensmeldung/rechtsschutz",
            name: "motive-schadensmeldung-recht",
            component: () =>
                import(
                    /* webpackChunkName: "schadensmeldung-recht" */ "@/views/SchadensmeldungRecht.vue"
                ),
            props: true,
        },
        {
            path: "/services/dokbox",
            name: "dokbox",
            component: () =>
                import(
                    /* webpackChunkName: "dokbox" */ "@/views/DocumentsDokbox.vue"
                ),
        },
        {
            path: "/services/unwetterwarnung/:contractId?",
            name: "services-unwetterwarnung",
            component: () =>
                import(
                    /* webpackChunkName: "unwetterwarnung" */ "@/views/UnwetterwarnungNeu.vue"
                ),
            props: true,
        },
        {
            path: "/services/unwetterwarnung-neu/:contractId",
            name: "services-unwetterwarnung-neu",
            component: () =>
                import(
                    /* webpackChunkName: "unwetterwarnung-neu" */ "@/views/UnwetterwarnungNeu.vue"
                ),
            props: true,
        },
        {
            path: "/profil",
            name: "profil",
            component: () =>
                import(/* webpackChunkName: "profil" */ "@/views/Profile.vue"),
        },
        {
            path: "/einstellungen",
            name: "einstellungen",
            component: () =>
                import(
                    /* webpackChunkName: "einstellungen" */ "@/views/Einstellungen.vue"
                ),
        },
        {
            path: "/hilfe",
            name: "hilfe",
            component: () =>
                import(/* webpackChunkName: "hilfe" */ "@/views/Chatvisor.vue"),
        },
        {
            path: "/services/video-meeting",
            name: "video-meeting",
            component: () =>
                import(
                    /* webpackChunkName: "video-meeting" */ "@/views/VideoMeeting.vue"
                ),
        },
        {
            path: "/services/berater/:contractId",
            name: "beraterdetails",
            component: () =>
                import(
                    /* webpackChunkName: "beraterdetails" */ "@/views/CoachDetails.vue"
                ),
            props: true,
        },
        {
            path: "/services/berater/:contractId?/video-termin/:agentId",
            name: "video-termin",
            component: () =>
                import(
                    /* webpackChunkName: "video-termin" */ "@/views/VideoTerminAnfrage.vue"
                ),
            props: true,
        },
        {
            path: "/services/video-termin-abschluss",
            name: "video-termin-abschluss",
            component: () =>
                import(
                    /* webpackChunkName: "video-termin-abschluss" */ "@/views/VideoTerminAbschluss.vue"
                ),
            meta: {
                requiresAuth: true,
            },
        },
        // {
        //     path: "/services/e-bike-tracker/:contractId?",
        //     name: "services-biketrax",
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "biketrax" */ "@/views/Biketrax.vue"
        //         ),
        //     props: true,
        // },
        {
            path: "/services/me1ns/me1nzuhause",
            name: "me1nzuhause",
            component: () =>
                import(
                    /* webpackChunkName: "me1nzuhause" */ "@/views/Me1nZuhause.vue"
                ),
        },
        {
            path: "/services/me1ns/me1nzuhause/vortrag:id",
            name: "me1nzuhause-vortrag",
            component: () =>
                import(
                    /* webpackChunkName: "me1nzuhause-vortrag" */ "@/views/Me1nZuhauseVortrag.vue"
                ),
            props: true,
        },
        // {
        //     path: "/services/me1ns/fit-bleiben",
        //     name: "services-schmerzlinderung",
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "schmerzlinderung" */ "@/views/WindhundPainPoints.vue"
        //         ),
        // },
        {
            path: "/services/me1ns/my21/",
            name: "my21",
            component: () =>
                import(/* webpackChunkName: "my21" */ "@/views/My21.vue"),
            props: true,
        },
        {
            path: "/services/me1ns/my21/:day",
            // path: "/services/my21/tag",
            name: "my21-day",
            component: () =>
                import(
                    /* webpackChunkName: "my21-day" */ "@/views/My21Day.vue"
                ),
            props: true,
        },
        // {
        //     path: "/:motive/vertrag/:contractId/e-bike-tracker",
        //     name: "biketrax",
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "biketrax" */ "@/views/Biketrax.vue"
        //         ),
        //     props: true,
        // },
        {
            path: "/:motive/vertrag/:contractId",
            name: "vertrag",
            component: () =>
                import(
                    /* webpackChunkName: "vertrag" */ "@/views/Contract.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/gutschein",
            name: "gutschein",
            component: () =>
                import(
                    /* webpackChunkName: "gutschein" */ "@/views/Gutschein.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/sepa-lastschrift",
            name: "sepa-lastschrift",
            component: () =>
                import(
                    /* webpackChunkName: "gutschein" */ "@/views/SepaLastschrift.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/kfz-begutachtung",
            name: "kfz-begutachtung",
            component: () =>
                import(
                    /* webpackChunkName: "kfz-begutachtung" */ "@/views/MotionsCloud.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/vertragsdetails",
            name: "vertragsdetails",
            component: () =>
                import(
                    /* webpackChunkName: "vertragsdetails" */ "@/views/ContractDetails.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/umsaetze",
            name: "umsaetze",
            component: () =>
                import(
                    /* webpackChunkName: "umsaetze" */ "@/views/ContractTransactions.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/berater",
            name: "motive-beraterdetails",
            component: () =>
                import(
                    /* webpackChunkName: "beraterdetails" */ "@/views/CoachDetails.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/fonds",
            name: "fonds",
            component: () =>
                import(/* webpackChunkName: "fonds" */ "@/views/Fonds.vue"),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/spontanrueckzahlung",
            name: "spontanrueckzahlung",
            component: () =>
                import(
                    /* webpackChunkName: "spontanrueckzahlung" */ "@/views/Spontanrueckzahlung.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/unwetterwarnung",
            name: "unwetterwarnung",
            component: () =>
                import(
                    /* webpackChunkName: "unwetterwarnung" */ "@/views/UnwetterwarnungNeu.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/einzahlung",
            name: "einzahlung",
            component: () =>
                import(
                    /* webpackChunkName: "einzahlung" */ "@/views/Einzahlung.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/anpassen",
            name: "anpassen",
            component: () =>
                import(
                    /* webpackChunkName: "anpassen" */ "@/views/Anpassen.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/uebersicht",
            name: "uebersicht",
            component: () =>
                import(
                    /* webpackChunkName: "uebersicht" */ "@/views/Uebersicht.vue"
                ),
            props: true,
        },
        {
            path: "/:motive/vertrag/:contractId/auszahlung",
            name: "auszahlung",
            component: () =>
                import(
                    /* webpackChunkName: "auszahlung" */ "@/views/Auszahlung.vue"
                ),
            props: true,
        },
        {
            path: "/bestfit",
            name: "bestfit",
            component: () =>
                import(/* webpackChunkName: "bestfit" */ "@/views/Bestfit.vue"),
        },
        // {
        //     path: "/:motive",
        //     name: "motiv",
        //     component: () =>
        //         import(/* webpackChunkName: "motiv" */ "@/views/Motive.vue"),
        //     props: true,
        // },
        {
            path: "/protected",
            name: "protected",
            component: Protected,
        },
        {
            path: "*",
            name: "page-not-found",
            component: PageNotFound,
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    if (
        to.meta.requiresAuth &&
        !(await checkPageAccess(to.fullPath, sessionStorage.getItem("ppw")))
    ) {
        next({
            name: "protected",
            query: {
                page: to.fullPath,
            },
        });
    } else if (to.path === "/aktion") {
        next(false);
    } else if (to.path.includes("http")) {
        const url = to.fullPath.substring(
            to.fullPath.indexOf("http"),
            to.fullPath.length
        );
        let urlSuffix = "?referrer=app";
        if (url.includes("?")) {
            urlSuffix = "&referrer=app";
        }
        Browser.open({ url: url + urlSuffix });
        Vue.gtm.trackView("In-App Browser", url);
        next(false);
    } else {
        next();
    }
});

router.afterEach((to) => {
    // Event Tracking - Virtual Page View
    let path = to.path;
    let name = to.name;
    let params = to.params;
    let maskedPath = to.path;
    if ("contractId" in to.params) {
        maskedPath = path.replace(/\d(?=\d{3})/g, "X");
    }

    // Check if logged in
    isLoggedIn()
        .then(() => {
            if (name === "dashboard") {
                name = name + " - eingeloggt";
            } else if (name === "login") {
                router.push({ name: "dashboard" });
                return;
            } else if (
                !params.contractId &&
                (name === "services-unwetterwarnung" ||
                    name === "services-biketrax")
            ) {
                let feature = "";
                if (name === "services-unwetterwarnung") {
                    path = { name: "services-unwetterwarnung" };
                    feature = "Unwetter";
                } else if (name === "services-biketrax") {
                    path = { name: "services-biketrax" };
                    feature = "EbikeTracker";
                }
                if (feature !== "") {
                    const contracts = store.state.contracts;
                    let foundContractId = false;
                    let featureCounter = 0;
                    for (let key in contracts) {
                        if (
                            "Features" in contracts[key] &&
                            feature in contracts[key].Features
                        ) {
                            if (featureCounter === 0) {
                                if (typeof path === "object") {
                                    path.params = {};
                                    path.params.contractId = key;
                                }
                                foundContractId = true;
                            }
                            featureCounter++;
                        }
                    }
                    if (feature === "Unwetter") {
                        store.commit(
                            "unwetterwarnungen/setContractsCounter",
                            featureCounter
                        );
                    } else if (feature === "EbikeTracker") {
                        store.commit(
                            "biketrax/setContractsCounter",
                            featureCounter
                        );
                    }
                    if (foundContractId) {
                        const motivesConfig = store.state.motivesConfig;
                        let selectedMotive = Object.values(
                            contracts[path.params.contractId].Motives
                        )[0];
                        let motivePath = "berater";
                        for (let key in motivesConfig) {
                            if (motivesConfig[key].motive === selectedMotive) {
                                motivePath = motivesConfig[key].path;
                                break;
                            }
                        }
                        path.params.motive = motivePath;
                        if (featureCounter > 1) {
                            path.params.shouldPresentContractSwitcherModal = true;
                        }
                    } else if (feature !== "EbikeTracker") {
                        router.push({ name: "dashboard" });
                        return;
                    }
                }
                router.replace(path);
                return;
            }
            Vue.gtm.trackView(name, maskedPath);
        })
        .catch(() => {
            if (name === "dashboard") {
                name = name + " - nicht eingeloggt";
            }
            if (!isPageLoggedOutAllowed(name)) {
                logout();
                return;
            }
            Vue.gtm.trackView(name, path);
        });
});

export default router;
